<template>
  <div class="content">
    <template>
      <v-card
        :style="
          $vuetify.breakpoint.xs
            ? 'margin: 4px'
            : 'margin: 0 18px 0 18px'
        "
      >
        <base-loading v-if="loading" />
        <div v-if="!loading">
          <crud-list
            v-model="tecnicos"
            :headers="headers"
            :slots="['item.telefones', 'item.status']"
            :actions="actions"
            :show-expand="true"
            :permission="'list_tecnico'"
            :sort-by="['nome']"
            :sort-desc="[false]"
            export-pdf-xlsx
          >
            <template v-slot:expanded-item="{ item }">
              <td
                v-if="item.unidades.length || item.fazendaProdutores.length"
                :colspan="headers.length"
                style="padding-left: 30px; padding-top: 10px;"
              >
                <div style="max-height: 500px;overflow-y: auto;">
                  <div v-if="item.unidades.length">
                    <v-simple-table
                      dense
                      class="mb-5"
                      style="border: 1px solid lightgrey;"
                    >
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th
                              colspan="4"
                              class="black--text font-weight-black"
                            >
                              Unidades de Negócio
                            </th>
                          </tr>
                          <tr>
                            <th>
                              CNPJ
                            </th>
                            <th>
                              Nome Fantasia
                            </th>
                            <th>
                              Razão Social
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="unidades in item.unidades"
                            :key="unidades.nome_fantasia"
                          >
                            <td>{{ unidades.cnpj }}</td>
                            <td>{{ unidades.nome_fantasia }}</td>
                            <td>{{ unidades.razao_social }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>

                  <div
                    v-if="item.fazendaProdutores.length"
                  >
                    <v-simple-table
                      dense
                      class="mb-5"
                      style="border: 1px solid lightgrey;"
                    >
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th
                              colspan="6"
                              class="black--text font-weight-black"
                            >
                              Produtores / Fazendas: {{ item.fazendaProdutores.length }} - Ativos: {{ item.fazendaProdutores.filter((e) => e.ativo === 1).length }}
                            </th>
                          </tr>
                          <tr>
                            <th>
                              Status
                            </th>
                            <th>
                              Fazenda
                            </th>
                            <th>
                              Matrícula
                            </th>
                            <th>Produtor</th>
                            <th>Unidade de negócio</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="fazendaProdutor in item.fazendaProdutores"
                            :key="fazendaProdutor.id"
                          >
                            <td>
                              <v-chip
                                v-if="!fazendaProdutor.ativo"
                                color="red lighten-1"
                                class="mb-2 pl-4 pr-4 my-1"
                                x-small
                                text-color="white"
                              >
                                <b>Inativo</b>
                              </v-chip>
                              <v-chip
                                v-if="fazendaProdutor.ativo"
                                color="green lighten-2"
                                class="mb-2 pl-4 pr-4 my-1"
                                x-small
                                text-color="white"
                              >
                                <b>Ativo</b>
                              </v-chip>
                            </td>
                            <td>{{ fazendaProdutor.fazenda.pessoajuridica.razao_social ? `${fazendaProdutor.fazenda.pessoajuridica.razao_social}` : `${fazendaProdutor.fazenda.pessoajuridica.razao_social}` }}</td>
                            <td>{{ fazendaProdutor.cod_produtor_fornecedor }}</td>
                            <td>{{ fazendaProdutor.produtor?.pessoafisica?.nome ? fazendaProdutor.produtor.pessoafisica.nome : (fazendaProdutor.produtor.pessoajuridica? fazendaProdutor.produtor.pessoajuridica.razao_social : null) }}</td>
                            <td>{{ fazendaProdutor.fazenda?.unidade_negocio.pessoajuridica ? fazendaProdutor.fazenda.unidade_negocio.pessoajuridica.nome_fantasia : '' }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </div>
              </td>
            </template>
            <template
              v-slot:btnCadastro
            >
              <v-col
                v-if="$store.getters.hasPermission('inserir_tecnico')"
              >
                <v-btn
                  block
                  class="text-none text-white"
                  color="primary"
                  title="Cadastrar novo técnico"
                  rounded
                  @click="$router.push({ path: 'tecnicos/cadastrar' })"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-file-plus
                  </v-icon>
                  Cadastrar
                </v-btn>
              </v-col>
            </template>
            <template v-slot:[`item.telefones`]="{ item }">
              <div
                v-for="(telefone, index) in item.telefones"
                :key="index"
              >
                <span v-if="telefone">
                  {{ `${index + 1}:  ${telefone}` }}
                  <br>
                </span>
              </div>
            </template>
            <template
              v-slot:[`item.status`]="{ item }"
            >
              <v-checkbox
                v-model="item.status"
                class="mt-0"
                color="success"
                :loading="false"
                :readonly="!hasPermission('ativar_tecnico')"
                hint="Ativar/Desativar técnico!"
                hide-details
                @change="TOGGLE_TECNICO_STATUS(item)"
              />
            </template>
          </crud-list>
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
  import store from '@/store'
  import TecnicosStore, { BOOTSTRAP, DELETE_TECNICO, TOGGLE_TECNICO_STATUS } from '@/store/modules/tecnicos'
  import JsPDF from 'jspdf'
  import moment from 'moment'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    components: {
    },
    data () {
      return {
        actions: [
          {
            title: 'Editar técnico',
            color: 'info darken-3',
            click: item => this.editarTecnico(item),
            icon: 'mdi-pencil',
            permission: 'editar_tecnico',
          },
          {
            title: 'Excluir Técnico',
            color: 'red darken-3',
            click: item => this.DELETE_TECNICO(item),
            icon: 'mdi-trash-can-outline',
            permission: 'excluir_tecnico',
          },
          {
            title: 'Exportar para PDF',
            color: '#D50000',
            click: item => this.exportPDF(item),
            icon: 'mdi-file-pdf',
            permission: 'list_tecnico',
          },
        ].filter(action => store.getters.hasPermission(action.permission)),
        headers: [
          { text: '', sortable: false, groupable: false, floatingfilter: false, value: 'data-table-expand' },
          { text: '', sortable: false, groupable: false, floatingfilter: false, value: 'actions', width: '40px' },
          {
            align: 'left',
            sortable: false,
            groupable: false,
            floatingfilter: false,
            text: 'Status',
            value: 'status',
            width: 'auto',
            report: true,
            styleXLSX: { type: 'alterValue', alterValue: { 1: 'Ativo', 0: 'Inativo' } },
            styleReport: { alterValue: { 1: 'Ativo', 0: 'Inativo' } },
          },
          { align: 'left', sortable: true, groupable: false, floatingfilter: true, text: 'CPF', value: 'cpf', width: 'auto', report: true },
          { align: 'left', sortable: true, groupable: false, floatingfilter: true, text: 'Nome', value: 'nome', width: 'auto', report: true },
          { align: 'left', sortable: true, groupable: true, floatingfilter: true, text: 'Papel', value: 'roles.description', width: 'auto' },
          { align: 'left', sortable: true, groupable: true, floatingfilter: true, text: 'Supervisor', value: 'supervisor.nome', width: 'auto' },
          { align: 'left', sortable: true, groupable: false, floatingfilter: true, text: 'RG', value: 'rg', width: 'auto' },
          { align: 'left', sortable: false, groupable: false, floatingfilter: false, text: 'Email', value: 'email', width: 'auto', report: true },
          { align: 'left', sortable: false, groupable: false, floatingfilter: false, text: 'Telefones', value: 'telefones', width: 'auto', report: true, styleXLSX: { type: 'telefone' } },
        ],
      }
    },
    computed: {
      ...mapState('tecnicos', ['loading', 'tecnicos', 'unidades']),
      ...mapGetters(['hasPermission']),
      isNotifica () {
        if (this.$user.get().role === 'gestor') {
          return true
        }
        return false
      },

    },
    async created () {
      if (!this.$store.hasModule('tecnicos')) { this.$store.registerModule('tecnicos', TecnicosStore) }
      this.BOOTSTRAP()
    },
    methods: {
      ...mapActions('tecnicos', [BOOTSTRAP, DELETE_TECNICO, TOGGLE_TECNICO_STATUS]),
      editarTecnico ({ id }) {
        this.$router.push({
          path: `/${this.$user.get().role}/tecnicos/alterar`,
          query: { id },
        })
      },

      async exportPDF (dados) {
        var doc = new JsPDF({
          orientation: 'portrait',
        })

        const docWidth = doc.internal.pageSize.width
        const docHeight = doc.internal.pageSize.height
        const logo = await loadImageAsBase64(window.location.origin + '/img/logo.png')

        const fontSize = 10
        const margin = { left: 10, right: 10, bottom: 10 }
        const dateNow = moment().format('DD/MM/YYYY')
        const horaNow = moment().format('HH:mm:ss')

        function addFooter (pageNumber) {
          doc.setFontSize(fontSize - 1)
          doc.text(dateNow, 10, docHeight - 10)
          doc.text('https://app.pioneiros.vet.br', docWidth / 2, docHeight - margin.bottom, { align: 'center' })
          doc.text('Página ' + pageNumber + ' / ' + totalPages, docWidth + 24, docHeight - 10, { align: 'right' })
        }

        function addHeader (name, logo, doc) {
          doc.addImage(logo, 'png', 10, 5, 38, 14)
          doc.setFontSize(16)
          doc.text(name, docWidth / 2, 15, { align: 'center' })
          doc.setFontSize(8)
          doc.text(dateNow, docWidth - 10, (15), { align: 'right' })
          doc.text(horaNow, docWidth - 10, (20), { align: 'right' })
        }

        async function loadImageAsBase64 (url) {
          const response = await fetch(url)
          const blob = await response.blob()

          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
          })
        }

        const addCabecalho = async () => {
          const supervisor = dados.supervisor && dados.supervisor.nome ? dados.supervisor.nome : 'Não encontrado'
          const bodySupervisorFormatado = {
            cpf: dados.cpf,
            nome: dados.nome,
            supervisor: supervisor,
            telefone: (dados.telefones || [])
              .filter(tel => tel)
              .map((telefone, index) => `${index + 1}: ${telefone}`)
              .join(' | '),
          }

          doc.line(margin.left, 24, docWidth - margin.right, 24)
          doc.autoTable({
            theme: 'plain',
            startY: 25,
            margin: { left: margin.left },
            styles: {
              textColor: 20,
              fillColor: [255, 255, 255],
              cellPadding: { top: 0, right: 5, bottom: 0, left: 0 },
              fontSize: 10,
              minCellHeight: 5,
            },
            columnStyles: {
              0: {
                cellWidth: 'auto',
                halign: 'left',
                cellPadding: { left: margin.left },
              },
              1: {
                cellWidth: 'auto',
                halign: 'left',
                cellPadding: { left: 5 },
              },
            },
            body: [
              [
                { content: `Nome: ${bodySupervisorFormatado.nome}`, styles: { cellPadding: { left: 0 } } },
                { content: `CPF: ${bodySupervisorFormatado.cpf}` },
              ],
              [
                { content: `Supervisor: ${bodySupervisorFormatado.supervisor}`, styles: { cellPadding: { left: 0 } } },
                { content: `Telefone: ${bodySupervisorFormatado.telefone}` },
              ],
            ],
          })
        }

        var totalPages = '{total_pages_count_string}'

        const startYUnNeg = doc.previousAutoTable ? doc.previousAutoTable.finalY + 20 : 40
        doc.line(margin.left, startYUnNeg, docWidth - margin.right, startYUnNeg)
        doc.setFontSize(12)
        doc.text('Unidades de negócio', 105, startYUnNeg + 4, { align: 'center' })

        doc.autoTable({
          theme: 'plain',
          startY: startYUnNeg + 6,
          columnStyles: {
            cnpj: { cellWidth: 62 },
            nome_fantasia: { cellWidth: 66 },
            cod_centro: { cellWidth: 62 },
          },
          styles: {
            lineColor: [0, 0, 0],
            cellPadding: 0.5,
          },
          headStyles: { lineWidth: { top: 0.2, right: 0, bottom: 0.2, left: 0 } },
          columns: [
            { title: 'CNPJ', dataKey: 'cnpj' },
            { title: 'Nome fantasia', dataKey: 'nome_fantasia' },
            { title: 'Código centro', dataKey: 'cod_centro' },
          ],
          body: dados.unidades,

          didParseCell: function (data) {
            if (data.section === 'head' && data.row.index === 0) {
              data.cell.styles.fontStyle = 'bold'
            }
          },

          margin: { top: 43, left: 10, right: 10, bottom: 10 },
        })

        const startYProdFazenda = doc.previousAutoTable ? doc.previousAutoTable.finalY + 20 : 40
        doc.line(margin.left, startYProdFazenda - 14, docWidth - margin.right, startYProdFazenda - 14)
        doc.setFontSize(12)

        const qtdFazendaProdutoresAtivos = dados.fazendaProdutores.filter((fp) => fp.ativo === 1).length

        doc.text('Produtores/Fazendas: ' + dados.fazendaProdutores.length + ' - Ativos: ' + qtdFazendaProdutoresAtivos, 105, startYProdFazenda - 10, { align: 'center' })

        const bodyProduFazenda = Object.values(dados.fazendaProdutores).map(fazendaProdutores => {
          const statusFazenda = fazendaProdutores.ativo === 1 ? 'Ativo' : 'Inativo'

          let nome_razao_social_produtor = ''

          if (fazendaProdutores.produtor.pessoa) {
            if (fazendaProdutores.produtor.pessoa.tipo.includes('PessoaFisica') && fazendaProdutores.produtor.pessoafisica) {
              nome_razao_social_produtor = fazendaProdutores.produtor.pessoafisica.nome || ''
            } else if (fazendaProdutores.produtor.pessoa.tipo.includes('PessoaJuridica') && fazendaProdutores.produtor.pessoajuridica) {
              nome_razao_social_produtor = fazendaProdutores.produtor.pessoajuridica.razao_social || ''
            }
          }

          return {
            status: statusFazenda,
            fazenda: fazendaProdutores.fazenda.pessoajuridica.razao_social,
            cod_produtor_fornecedor: fazendaProdutores.cod_produtor_fornecedor,
            empresa_convenio_id: fazendaProdutores.empresa_convenio_id,
            produtor: nome_razao_social_produtor,
            unidade_negocio: fazendaProdutores.fazenda.unidade_negocio.pessoajuridica.nome_fantasia,
            // telefone: (fazendaProdutores.telefones || [])
            //   .filter(tel => tel)
            //   .map((telefone, index) => `${index + 1}: ${telefone}`)
            //   .join(' | '),
          }
        })

        doc.autoTable({
          theme: 'plain',
          startY: startYProdFazenda - 8,
          columnStyles: {
            status: { cellWidth: 14 },
            fazenda: { cellWidth: 70 },
            cod_produtor_fornecedor: { cellWidth: 19 },
            empresa_convenio_id: { cellWidth: 19 },
            produtor: { cellWidth: 50 },
            unidade_negocio: { cellWidth: 37 },
          },
          styles: {
            lineColor: [0, 0, 0],
            cellPadding: 0.5,
          },
          headStyles: { lineWidth: { top: 0.2, right: 0, bottom: 0.2, left: 0 } },
          columns: [
            { title: 'Status', dataKey: 'status' },
            { title: 'Fazenda', dataKey: 'fazenda' },
            { title: 'Matrícula', dataKey: 'cod_produtor_fornecedor' },
            { title: 'Produtor', dataKey: 'produtor' },
            { title: 'Unidades de negócio', dataKey: 'unidade_negocio' },
          ],
          body: bodyProduFazenda,

          didParseCell: function (data) {
            if (data.section === 'head' && data.row.index === 0) {
              data.cell.styles.fontStyle = 'bold'
            }
          },
          margin: { top: 43, left: 10, right: 10, bottom: 10 },
          willDrawPage: () => {
            addCabecalho()
            addHeader('Vínculos do técnico', logo, doc)
          },
          didDrawPage: (data) => {
            addFooter(data.pageNumber)
          },
        })

        doc.line(margin.left, doc.lastAutoTable.finalY, docWidth - margin.right, doc.lastAutoTable.finalY)
        let finalY = doc.lastAutoTable.finalY

        if (finalY > 150) {
          doc.addPage()
          addCabecalho()
          addHeader('Vínculos do técnico', logo, doc)
          finalY = 43
          doc.line(margin.left, finalY, docWidth - margin.right, finalY)
        }

        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPages)
        }
        doc.save('Vinculos do técnico.pdf')
      },
    },
  }
</script>
